export default "__VITE_ASSET__CAYT629N__"